import React from 'react';
import styles from './Landing.scss';

const PrivacyPolicy = () => (
  <div className={styles.Landing}>
    <h1>ПОЛИТИКА ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ (Конфиденциальности)</h1>

    <p>
      Политика обработки персональных данных (далее по тексту – «Политика») разработана в
      соответствии с федеральными законами и подзаконными актами Российской Федерации, определяющими
      случаи и особенности обработки персональных данных и обеспечения безопасности и
      конфиденциальности такой информации. Политика содержит информацию о том, как NEDVEX
      осуществляет обработку и защиту персональных данных.
    </p>

    <h3>1. ОБЩИЕ ПОЛОЖЕНИЯ</h3>

    <p>
      1.1. Настоящая политика конфиденциальности действует в отношении всей информации, включая
      персональные данные в понимании применимого законодательства (далее — «Персональная
      информация»), которую ООО «НЕДВЕКС» (далее по тексту - Сервис) и/или его аффилированные лица,
      могут получить от лиц, в процессе использования программы «НЕДВЕКС» для мобильных устройств
      (далее по тексту – Пользователь), а также в ходе исполнения «НЕДВЕКС» / его аффилированными
      лицами любых соглашений и договоров, заключенных с Пользователем в связи с использованием
      Пользователем Сервиса. «НЕДВЕКС» может также получать Персональную информацию от своих
      партнеров (далее — «Партнеры»), сайтов программ, продуктов или сервисов, которые Пользователь
      использует и из других источников с общедоступными персональными данными. В соответствующих
      случаях передача Персональной информации возможна только в случаях, установленных применимым
      законодательством, и осуществляется на основании специальных договоров между «НЕДВЕКС» и
      каждым из Партнеров.
    </p>

    <p>
      1.2. Под обработкой персональных данных понимаются предусмотренные Федеральным законом от
      27.07.2006 г. № 152-ФЗ «О персональных данных» действия или совокупность действий, совершаемых
      с использованием средств автоматизации или без использования таких средств с персональными
      данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление,
      изменение), извлечение, использование, передачу (распространение, предоставление, доступ)
      удаление, уничтожение персональных данных.
    </p>

    <p>
      1.3. Для обеспечения использования Пользователем Сервиса Персональная информация собирается и
      используется обществом с ограниченной ответственностью «НЕДВЕКС», юридическое лицо, созданное
      по законодательству Российской Федерации и зарегистрированное по адресу: 354207, Краснодарский
      край, город Сочи, Лазаревский район, ул. Летняя, строение 15/2, Почтовый адрес: 354000,
      Краснодарский край, г. Сочи, Центральный район, пер. Морской, д.1/1а, ИНН 2318043183, КПП
      231801001, ОГРН 1162366056830.
    </p>

    <p>
      1.4. Настоящая Политика является неотъемлемой частью{' '}
      <a href="http://app.nedvex.ru/eula">Пользовательского соглашения</a>, а также иных заключаемых
      с Пользователем договоров в процессе пользования Сервисами NEDVEX, когда это прямо
      предусмотрено их условиями.
    </p>

    <p>
      1.5. Для конкретных услуг Сервис может публиковать дополнительные условия, дополняющие
      настоящую Политику.
    </p>

    <p>
      1.6. Сервис обрабатывает персональные данные автоматизированным и неавтоматизированным
      способами, с использованием средств вычислительной техники и без использования таких средств.
    </p>

    <p>1.7. Специальные категории персональных данных не распространяется.</p>

    <p>1.8. Биометрические персональные данные не собираются и не распространяются.</p>

    <h3>2. ЦЕЛЬ НАСТОЯЩЕЙ ПОЛИТИКИ</h3>

    <p>2.1. При обработке персональных данных Оператор руководствуется следующими принципами:</p>

    <p>2.1.1. Соблюдение и обеспечение законности обработки персональных данных;</p>

    <p>
      2.1.2. Соблюдение целей обработки персональных данных целям, заявленным и определенным при
      сборе персональных данных;
    </p>

    <p>2.1.3. Обеспечение достоверности обрабатываемых персональных данных;</p>

    <p>
      2.1.4. Соблюдение соответствия объема и характера обрабатываемых персональных данных и
      способов их обработки, целям сути необходимости обработки персональных данных.
    </p>

    <p>
      2.2. При обработке персональных данных Оператор руководствуется следующими нормативными
      правовыми актами:
    </p>

    <p>2.2.1. Конституция Российской Федерации;</p>

    <p>2.2.2. Гражданский кодекс Российской Федерации;</p>

    <p>2.2.3. Федеральный закон «О персональных данных» от 27 июля 2006 г. № 152-ФЗ;</p>

    <p>
      2.2.4. Гражданско-правовые договоры и иные документы, разрабатываемые в соответствии с
      требованиями законодательства Российской Федерации;
    </p>

    <p>
      2.2.5. Иные нормативные акты органов местного самоуправления и органов государственной власти
      РФ регулирующие вопрос обработки персональных данных;
    </p>

    <p>
      2.3. Хранение персональных данных осуществляется в порядке, предусмотренном Федеральным закона
      «О персональных данных» от 27.07.2006 № 152-ФЗ и настоящей Политикой.
      <br />
      <br />
      Хранение персональных данных обеспечивается с учетом требований к срокам и порядку хранения
      персональных данных и требований к локализации баз данных, в которых хранятся персональные
      данные субъектов персональных данных, на территории РФ.
    </p>

    <p>
      2.4. Защита Персональной информации и конфиденциальность чрезвычайно важны для НЕДВЕКС.
      Поэтому при использовании Пользователем Сервисов, НЕДВЕКС защищает и обрабатывает Персональную
      информацию Пользователя в строгом соответствии с применимым законодательством.
    </p>

    <p>
      2.5. НЕДВЕКС настоящей Политикой, прозрачно и открыто информирует Пользователя о следующий
      аспектах:
    </p>

    <ol type="a">
      <li>
        зачем и как НЕДВЕКС собирает и использует («обрабатывает») Персональную информацию
        Пользователя, когда Пользователь используете Сервис;
      </li>
      <li>
        какова роль и обязанности НЕДВЕКС как юридического лица, принимающего решение о том, зачем и
        как обрабатывать Персональную информацию Пользователя;
      </li>
      <li>
        какие инструменты Пользователь можете использовать для сокращения объема собираемой НЕДВЕКС
        Персональной информации;
      </li>
      <li>каковы права Пользователя в рамках проводимой обработки Персональной информации.</li>
    </ol>

    <h3>3. ПЕРЕЧЕНЬ ИНФОРМАЦИИ СОБИРАЕМОЙ НЕДВЕКС О ПОЛЬЗОВАТЕЛЕ</h3>

    <p>
      3.1. Персональная информация, собранная в процессе работы Сервиса, может различаться в
      зависимости от того, использует Пользователь для доступа к ним учетную запись или нет. НЕДВЕКС
      не проверяет предоставленную Пользователю Персональную информацию за исключением случаев,
      предусмотренных Пользовательским соглашением, и не может судить о ее достоверности, а также о
      том, обладает ли Пользователь достаточной правоспособностью для предоставления Персональной
      информации. Тем не менее НЕДВЕКС исходит из того, что Пользователь предоставляет достоверную и
      достаточную Персональную информацию, а также своевременно обновляет ее.
    </p>

    <p>
      3.2. НЕДВЕКС может собирать следующие категории Персональной информации о Пользователе во
      время использования Сервиса:
    </p>

    <ol type="i">
      <li>
        Персональная информация, предоставленная Пользователем при регистрации (создании учетной
        записи), такая как имя (ФИО), номер телефона, адрес электронной почты, адрес регистрации;
      </li>
      <li>
        Сведения о профессиональной деятельности, фотографии, другие сведения, предоставленные
        субъектом персональных данных в соответствии с Пользовательским соглашением, содержащиеся в
        заявлениях, письмах, соглашениях и иных документах
      </li>
      <li>
        электронные данные (HTTP-заголовки, IP-адрес, файлы cookie, веб-маяки/пиксельные теги,
        данные об идентификаторе браузера, информация об аппаратном и программном обеспечении,
        данные сети wi-fi);
      </li>
      <li>дата и время осуществления доступа к Сервису;</li>
      <li>
        информация о Вашей активности во время использования Сервиса (например, история поисковых
        запросов, данные о бронировании в Сервисе, данные о просмотренных ресторанах, а также
        предпочтения;
      </li>
      <li>информация о геолокации;</li>
      <li>
        иная информация о Пользователе, необходимая для обработки в соответствии с условиями
        Пользовательского соглашения;
      </li>
      <li>
        информация о Пользователе, которую НЕДВЕКС получает от Партнеров в соответствии с условиями
        соглашений, заключенных между Пользователем и соответствующим Партнером, и соглашений,
        заключенных между НЕДВЕКС и Партнером;
      </li>
      <li>
        данные платежных карт Пользователя, иная платежная информация, предоставленная
        Пользователем, а также полученная от Партнеров или иных лиц, участвующих в проведении
        платежной операции с использованием Сервиса.
      </li>
    </ol>

    <p>
      Также НЕДВЕКС использует файлы cookie и веб-маяки (включая пиксельные теги) для сбора
      Персональной информации и связывания такой личной информации с Пользовательским устройством и
      веб-браузером.
    </p>

    <p>
      3.3. НЕДВЕКС не собирает данные с целью составления «портрета» пользователя в той степени, при
      которой это может существенно повлиять на права и свободы Пользователя в соответствии с
      применимым законодательством.
    </p>

    <h3>4. ЦЕЛИ И ПРАВОВЫЕ ОСНОВАНИЯ ОБРАБОТКИ ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЯ</h3>

    <p>
      4.1. НЕДВЕКС не вправе обрабатывать Персональную информацию Пользователя без достаточных на то
      правовых оснований. Поэтому НЕДВЕКС обрабатывает Персональную информацию Пользователя только в
      том случае, если:
    </p>

    <ol type="i">
      <li>
        обработка необходима для выполнения условий Пользовательского соглашения между Пользователем
        и НЕДВЕКС,
      </li>
      <li>обработка необходима для соблюдения установленных законодательством обязательств;</li>
      <li>
        когда это предусмотрено применимым законодательством, обработка необходима для обеспечения
        законных интересов НЕДВЕКС в случае, если такая обработка не оказывает существенного влияния
        на интересы Пользователя, его фундаментальные права и свободы. НЕДВЕКС просит обратить
        внимание, что при обработке персональной информации Пользователя на указанном основании,
        НЕДВЕКС всегда будет стремиться поддерживать баланс между своими законными интересами и
        защитой конфиденциальности Пользователя.
        <br />
        <br />
        НЕДВЕКС обрабатывает Персональную информацию Пользователя для обеспечения своих законных
        интересов, например, в следующих случаях:
        <ol type="a">
          <li>Для понимания, как Пользователь взаимодействуете с Сервисом;</li>
          <li>
            С целью совершенствования, изменения, персонализации или иного улучшения Сервиса в
            интересах всех пользователей;
          </li>
          <li>
            Для предложения Пользователю других продуктов и сервисы НЕДВЕКС или других компаний,
            которые, исходя из рекомендаций системы Сервиса, могут заинтересовать Пользователя (т.
            е. показывать Пользователю рекламу, учитывающую его интересы);
          </li>
        </ol>
      </li>
      <li>
        для конкретных целей, либо в соответствии с требованием применимого законодательства НЕДВЕКС
        может запросить у Пользователя отдельное согласие на обработку Персональной информации.
        Настоящей Политикой НЕДВЕКС информируем Пользователя, а Пользователь подтверждает, что у
        него нет никаких обязательств по предоставлению НЕДВЕКС какой-либо Персональной информации
        при использовании Пользователем Сервиса, и такое предоставление основано исключительно на
        свободной воле Пользователя. Вместе с тем Пользователь осознает, что без предоставления
        Персональной информации НЕДВЕКС не сможет предоставить Пользователю возможность
        воспользоваться Сервисом, а использование Сервиса Пользователем будет ограничено и/или
        невозможно.
      </li>
    </ol>

    <p>4.2. НЕДВЕКС обрабатывает Персональную информацию Пользователя для следующих целей:</p>

    <ol type="i">
      <li>предоставление Пользователю доступа к Сервису;</li>
      <li>предоставление доступа Пользователю к учетной записи;</li>
      <li>
        осуществление связи с Пользователем для направления уведомлений, запросов и информации,
        относящейся к работе Сервиса, выполнения соглашений с Пользователем и обработки запросов и
        заявок от Пользователя;
      </li>
      <li>
        персонализация рекламы и предложений с учетом предпочтений Пользователя, истории поиска и
        другой Персональной информации о Пользователе, доступной НЕДВЕКС;
      </li>
      <li>
        повышение удобства использования Сервиса, в том числе для показа наиболее релевантных
        результатов поиска и предоставления более персонализированной информации, а также для
        улучшения других продуктов, приложений и Сервисов НЕДВЕКС;
      </li>
      <li>создание новых продуктов, утилит и предложений НЕДВЕКС;</li>
      <li>защита прав Пользователя и прав НЕДВЕКС;</li>
      <li>
        сбор, обработка и представление статистических данных, больших данных и других исследований;
      </li>
      <li>выявление угроз безопасности для Сервиса, пользователей, НЕДВЕКС и/или третьих лиц;</li>
      <li>
        организация приема платежей Пользователем, а также осуществления оплаты товаров и услуг с
        использованием Сервиса.
      </li>
    </ol>

    <p>
      4.3. В состав Программы в качестве отдельных ее компонентов входит стороннее программное
      обеспечение – Яндекс. Метрика и Google Analytics (далее – «Полученные данные»). Условия работы
      стороннего программного обеспечения расположены по адресу{' '}
      <a href="https://yandex.ru/legal/metrica_termsofuse/">
        https://yandex.ru/legal/metrica_termsofuse/
      </a>{' '}
      и по адресу{' '}
      <a href="https://support.google.com/analytics/answer/4597324?hl=ru">
        https://support.google.com/analytics/answer/4597324?hl=ru
      </a>
    </p>

    <h3>5. ЗАЩИТА ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЯ</h3>

    <p>
      5.1. В большинстве случаев Персональная информация обрабатывается автоматически без доступа к
      ней кого-либо из сотрудников НЕДВЕКС. В случае если такой доступ понадобится, то он может быть
      предоставлен только тем сотрудникам НЕДВЕКС, которые нуждаются в этом для выполнения своих
      задач. Для защиты и обеспечения конфиденциальности данных все сотрудники должны соблюдать
      внутренние правила и процедуры в отношении обработки Персональной информации. Они также должны
      следовать всем техническим и организационным мерам безопасности, действующим для защиты
      Персональной информации Пользователя.
    </p>

    <p>
      5.2. НЕДВЕКС также внедрил достаточные технические и организационные меры для защиты
      Персональной информации от несанкционированного, случайного или незаконного уничтожения,
      потери, изменения, недобросовестного использования, раскрытия или доступа, а также иных
      незаконных форм обработки. Данные меры безопасности были реализованы с учетом современного
      уровня техники, рисков, связанных с обработкой и характером Персональной информации.
    </p>

    <h3>6. ДОСТУП К ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЯ И ЕЕ ПЕРЕДАЧА</h3>

    <p>
      6.1. В рамках НЕДВЕКС
      <br />
      <br />
      НЕДВЕКС может передавать Персональную информацию Пользователя своим сотрудникам (в пределах,
      указанных настоящей Политикой). НЕДВЕКС также может передавать Персональную информацию
      Пользователя своим аффилированным лицам.
      <br />
      <br />
      Если иное не установлено условиями использования Сервиса, предоставляемых НЕДВЕКС, во всех
      случаях Персональная информация будет обрабатываться только для целей, изложенных в разделе 4
      настоящей Политики.
    </p>

    <p>
      6.2. Вне НЕДВЕКС
      <br />
      <br />
      НЕДВЕКС также может передавать Персональную информацию третьим лицам, для достижения целей,
      указанных в разделе 5 настоящей Политики.
      <br />
      <br />К таким третьим лицам могут относиться:
      <ol type="i">
        <li>
          Партнеры, такие как владельцы сайтов и приложений, рекламные сети и другие партнеры,
          предоставляющие НЕДВЕКС услуги, связанные с размещением и отображением рекламы в Сервисе,
          которые принадлежат таким партнерам или контролируются ими;
        </li>
        <li>
          рекламодатели или другие Партнеры, которые отображают для Пользователя рекламу в Сервисе;
        </li>
        <li>
          лица, предоставляющие информацию для выявления угроз безопасности для Сервиса,
          пользователей, НЕДВЕКС и/или третьих лиц;
        </li>
        <li>
          лица, участвующие в организации приема платежей от Пользователя и проведении платежных
          операций с использованием Сервиса (международные платежные системы, поставщики платежных
          инструментов, банки и иные финансовые организации и т.д.).
        </li>
      </ol>
    </p>

    <p>
      6.3. НЕДВЕКС также может передавать Персональную информацию третьим лицам:
      <ol type="i">
        <li>
          третьим лицам, которым произведена уступка прав или обязанностей по договорам, связанным с
          предоставлением пользователям Сервисов, или которые осуществляют контроль иным образом над
          лицами, предоставляющими Сервисы, в результате их приобретения (посредством приобретения
          юридических лиц, объектов интеллектуальной собственности, имущества, имущественных прав и
          иным образом);
        </li>
        <li>
          любому национальному и/или международному регулирующему органу, правоохранительным
          органам, центральным или местным исполнительным органам власти, другим официальным или
          государственным органам или судам, в отношении которых НЕДВЕКС обязан предоставлять
          информацию в соответствии с применимым законодательством по соответствующему запросу;
        </li>
        <li>
          третьим лицам, в случае если Пользователь выразил согласие на передачу своей Персональной
          информации либо передача Персональной информации требуется для предоставления Пользователю
          соответствующего Сервиса или выполнения определенного соглашения или договора,
          заключенного с Пользователем;
        </li>
        <li>
          любому третьему лицу в целях обеспечения правовой защиты НЕДВЕКС или третьих лиц при
          нарушении Пользователем Пользовательского соглашения сервиса НЕДВЕКС, настоящей Политики,
          либо в ситуации, когда существует угроза такого нарушения.
        </li>
      </ol>
    </p>

    <h3>7. ПОРЯДОК ХРАНЕНИЯ И ОБРАБОТКИ ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЯ</h3>

    <p>7.1. Персональная информация Пользователя храниться в Российской Федерации.</p>

    <p>
      7.2. НЕДВЕКС осуществляет запись, систематизацию, накопление, хранение, уточнение (обновление,
      изменение), извлечение персональных данных граждан Российской Федерации с использованием баз
      данных, находящихся на территории Российской Федерации.
    </p>

    <h3>8. КАК ДОЛГО СЕРВИС ХРАНИТ ПЕРСОНАЛЬНУЮ ИНФОРМАЦИЮ ПОЛЬЗОВАТЕЛЯ</h3>

    <p>
      8.1. НЕДВЕКС хранит Персональную информацию Пользователя столько времени, сколько это
      необходимо для достижения цели, для которой она была собрана, или для соблюдения требований
      законодательства и нормативных актов.
    </p>

    <p>
      8.2. Если Пользователь хочет, чтобы какая-либо Персональная информация о Пользователе была
      удалена из баз данных НЕДВЕКС, Пользователь можете самостоятельно удалить необходимую
      Персональную информацию через интерфейс Сервиса (где это применимо).
    </p>

    <h3>9. ПРАВА И ОБЯЗАННОСТИ ПОЛЬЗОВАТЕЛЯ</h3>

    <p>
      9.1. Какими правами обладаете Пользователь
      <br />
      <br />
      В случае если это предусмотрено применимым законодательством, Пользователь имеете право на
      доступ к своей Персональной информации, обрабатываемой НЕДВЕКС в соответствии с настоящей
      Политикой.
      <br />
      <br />
      Если Пользователь считает, что какая-либо информация, которую НЕДВЕКС хранит о нем,
      некорректная или неполная, Пользователь можете войти в свою учетную запись и исправить
      Персональную информацию самостоятельно.
      <br />
      <br />
      Если это предусмотрено применимым законодательством, Пользователь имеете право:
      <ol>
        <li>
          ознакомиться с информацией, которую НЕДВЕКС хранит о Пользователе, в том числе посредством
          учетной записи;
        </li>
        <li>
          требовать удаления Персональной информации или ее части, а также отзывать согласие на
          обработку персональной информации Пользователя;
        </li>
        <li>требовать ограничений на обработку Персональной информации Пользователя;</li>
        <li>
          возражать против обработки Персональной информации Пользователя, если это предусмотрено
          применимым законодательством.
        </li>
      </ol>
      НЕДВЕКС выполняет указанные запросы в соответствии с применимым законодательством.
      <br />
      <br />
      В случаях, предусмотренных применимым законодательством, Пользователь можете также обладать
      другими правами, не указанными выше.
      <br />
      <br />
      При использовании Пользователем Сервиса передача Персональной информации осуществляется c
      согласия Пользователя, выражающего свободную волю и интерес Пользователя, (в частности, на
      основании договора между Пользователем и НЕДВЕКС) и не является обязанностью по закону.
    </p>

    <p>
      9.2. Обязанности Пользователя
      <ol>
        <li>Предоставить исключительно актуальные и достоверные персональные данные.</li>
        <li>
          Своевременно предоставлять информацию, необходимую для актуализации персональных данных, в
          предусмотренных законом и/или Пользовательским соглашением случаях
        </li>
      </ol>
    </p>

    <p>
      9.3 Как Пользователь можете реализовать свои права
      <br />
      <br />
      Для осуществления вышеуказанных прав, необходимо войти в свою учетную запись, а в случае
      отсутствия специальной функции в интерфейсе свяжитесь с НЕДВЕКС.
      <br />
      <br />
      Если Пользователь не удовлетворен тем, как НЕДВЕКС обрабатывает Персональную информацию
      Пользователя, Пользователю необходимо сообщить НЕДВЕКС, а НЕДВЕКС в свою очередь обязуется
      рассмотреть претензию Пользователя и предоставить ответ в разумные сроки. Если Пользователь не
      удовлетворен ответом НЕДВЕКС, Пользователь имеет право подать жалобу в компетентный орган.
    </p>

    <h3>10. ОБНОВЛЕНИЕ НАСТОЯЩЕЙ ПОЛИТИКИ</h3>

    <p>
      10.1. В настоящую Политику могут быть внесены изменения. НЕДВЕКС имеет право вносить изменения
      по своему усмотрению, в том числе, но не ограничиваясь, в случаях, когда соответствующие
      изменения связаны с изменениями в применимом законодательстве, а также когда соответствующие
      изменения связаны с изменениями в работе Сервиса.
    </p>

    <p>
      10.2. НЕДВЕКС обязуется не вносить существенных изменений, не налагать дополнительных
      обременений или ограничений прав Пользователя, установленных настоящей Политикой без
      уведомления Пользователя. Пользователи будут уведомлены о таких изменениях. Соответствующие
      уведомления могут быть отображены Сервисе (например, через всплывающее окно или баннер) до
      того, как такие изменения вступят в силу, или могут быть отправлены Пользователю по другим
      каналам связи (например, по электронной почте, если Пользователь предоставил НЕДВЕКС
      контактные данные).
    </p>

    <h3>11. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</h3>

    <p>
      11.1. Настоящая Политика подлежит актуализации в случае изменения законодательства РФ,
      регулирующего обработку персональных данных, а также может быть изменена в любое время по
      усмотрению Сервиса.
    </p>

    <p>
      11.2. В случае, если по тем или иным причинам одно или несколько положений настоящих Правил
      будут признаны судом недействительными или не имеющими юридической силы, это не влечет
      недействительности применимости остальных положений.
    </p>

    <p>
      11.3. НЕДВЕКС приветствует вопросы и предложения от Пользователей, касающиеся исполнения или
      изменения настоящей Политики. Пользователь может обратится с вопросом касаемо условий
      настоящей Политики по адресу, указанному ниже. Пользователь также может воспользоваться этим
      адресом для направления запросов о реализации прав или жалоб относительно некорректности
      Персональной информации или незаконности ее обработки.
    </p>

    <p>ООО «НЕДВЕКС» ИНН 2318043183</p>

    <p>E-mail: content@nedvex.ru</p>
  </div>
);

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/containers/Landing/PrivacyPolicy.jsx